import { DeviceDto } from "@/api/query.schemas";
import { MIN_CORE_CONFIG_SEMVER } from "@/constants";
import { gte, valid } from "semver";

export const isCoreV3Device = (device?: DeviceDto) => {
    return (
        device?.deviceType === "Core" &&
        !!device.fwVersion &&
        !!valid(device.fwVersion) &&
        gte(device.fwVersion, MIN_CORE_CONFIG_SEMVER)
    );
};
